(function(angular){
    'use strict';

    angular.module('aprima-core-ui').component('apErxRequestPatient', {
        templateUrl: '/core-ui/component-views/ap-erx-request-patient.html',
        bindings: {
            requestedPatient: '<',
            currentPatient: '<?',
        },
        controllerAs: 'vm',
        controller: [
            ApErxRequestPatient,
        ],
    });

    function ApErxRequestPatient(
    ) {
        var vm = this;
        vm.isOpen = false;
    }

})(window.angular);
